module.exports = __webpack_public_path__ + "static/media/challenges.9def07ac.png";